import { helpers } from '@vuelidate/validators'
import type { ValidatorFn } from '@vuelidate/core'

const passwordComplexity: ValidatorFn = (value): boolean => {
  return !helpers.req(value) ||
    (
      value.length >= 8 &&
      /\d/.test(value) && // contains at least one number
      /[a-z]/.test(value) && // contains at least one lowercase letter
      /[A-Z]/.test(value) // contains at least one uppercase letter
    )
}

export default passwordComplexity
